import { t } from "@lingui/macro";
import React from "react";

import { PlaceIcon } from "../../../../../../../../components/icons_v2/general";
import {
  HStack,
  VStack,
  Text,
  Box,
} from "../../../../../../../../components/primitive";

type PublicRequestBodyProps = {
  location?: string;
  time?: string;
};
export const PublicRequestBody = ({
  location,
  time,
}: PublicRequestBodyProps) => {
  return (
    <HStack justifyContent="space-between" alignItems="center">
      <VStack>
        {location ? (
          <HStack alignItems="center" gap={1}>
            <Text variant="mainTiny" color="text-secondary">
              {location}
            </Text>
            <PlaceIcon color="icon-disabled" />
          </HStack>
        ) : null}
        <Text variant="mainBaseSemiBold" color="text-primary">
          {time ?? ""}
        </Text>
      </VStack>
      <HStack>
        <Box
          backgroundColor={"surface-user-selectable-colorC-subtlest"}
          px={2}
          py={1}
          borderRadius="2"
        >
          <Text color={"text-user-selectable-colorC"} variant="mainTiny">
            {t`Request Available`}
          </Text>
        </Box>
      </HStack>
    </HStack>
  );
};
